import React, {Component} from 'react';
import {graphql} from 'react-relay';
import CountByDeviceBarChart from '../../../../components/CountByDeviceBarChart';
import withWidgetHeaderAndFooter from '../../../../components/withWidgetHeaderAndFooter';
import withWidgetData from '../../../../components/withWidgetData';
import withReportFilterProps from '../../../../components/withReportFilterProps';
import notifyPhantomWhenMounted from '../../../../components/notifyPhantomWhenMounted';

@withReportFilterProps
@withWidgetData(
  graphql`
    query CountByDeviceWidgetQuery(
      $widgetId: ID!
      $from: String!
      $to: String!
      $deviceIds: [ID]!
      $filterComments: Boolean!
      $demoData: Boolean!
      $questionFilters: [QuestionFilterInput]
      $aggregateQuestions: [ID]
      $groupByLocation: Boolean
    ) {
      widget(id: $widgetId) {
        id
        name
        config {
          subtitle
          hideHeader
          question {
            text {
              language
              text
            }
            answersReport(
              from: $from
              to: $to
              deviceIds: $deviceIds
              filterComments: $filterComments
              demoData: $demoData
              questionFilters: $questionFilters
              aggregateQuestions: $aggregateQuestions
              groupByLocation: $groupByLocation
            ) {
              count
              ...CountByDeviceBarChart_answersReport
            }
          }
        }
      }
    }
  `,
)
@notifyPhantomWhenMounted()
@withWidgetHeaderAndFooter({subtitleMessageId: 'numberOfAnswersPerTerminal'})
class CountByDeviceWidget extends Component {
  render() {
    const widget = this.props.widget;
    const question = widget.config.question;
    return (
      <CountByDeviceBarChart
        answersReport={question.answersReport}
        height={this.props.bodyHeight}
        width={this.props.width}
        uniqueId={widget.id}
      />
    );
  }
}

export default CountByDeviceWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CountByDeviceWidget/CountByDeviceWidget.js